import {useEffect,useState} from 'react';
import {errorMessage} from './api';
import {readTextPreview,TEXT_PREVIEW_LIMIT} from './markdown-reader';

export function useTextPreview(url:string,revision?:string){
 const [preview,setPreview]=useState({text:'',error:'',loading:true,truncated:false});
 useEffect(()=>{
  if(!url)return;
  const abort=new AbortController();setPreview({text:'',error:'',loading:true,truncated:false});
  void (async()=>{
   try{
    const response=await fetch(url,{signal:abort.signal,headers:{Range:`bytes=0-${TEXT_PREVIEW_LIMIT}`},credentials:'same-origin'});
    const value=await readTextPreview(response,TEXT_PREVIEW_LIMIT,revision);
    if(!abort.signal.aborted)setPreview({...value,error:'',loading:false});
   }catch(value){if(!abort.signal.aborted)setPreview({text:'',error:errorMessage(value),loading:false,truncated:false});}
  })();
  return()=>abort.abort();
 },[url,revision]);
 return preview;
}
